<template>
  <div class="brief-container">
    <h2>中国话语与世界文学研究中心2023年度工作报告</h2>
    <div class="brief-content">
      <p>
        作为上海外国语大学2022年底设立的多语种、跨学科、实体化运作学术研究机构，中国话语与世界文学研究中心以特色化、高端化、国际化为发展定位，以培育、申报、完成国家级与省部级重大前沿课题、孵化标志性成果为导向，致力构建融通中外的话语体系。在上海外国语大学校党委和各级领导的关怀指导、上海全球治理与区域国别研究院的鼎力支持下，研究中心2023年在学术创新、成果转化、人文交流、学科建设、人才培养与话语传播等方面协同发展，积极助力我校外语学科发展。<strong>中国话语与世界文学研究中心</strong>于2022年正式揭牌成立。
      </p>
      <div class="video-content">
        <div class="player-container">
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
          </video-player>
        </div>
      </div>
      <p style="text-align: center;"><strong>一、学术创新，拓展研究领域</strong></p>
      <p>
        研究中心主持、在研国家级、省部级科研课题10项。团队成员在德语文学、英语文学、比较文学、区域国别学、历史学、文化学等研究领域发表论文24篇，其中A&HCI与CSSCI来源期刊共计15篇，占比63%，在境外学术期刊发表的外语论文占比21%，多篇论文被人大复印报刊资料、中国社会科学网等转载。
      </p>
      <p style="text-align: center;"><strong>二、成果转化，彰显学术品牌</strong></p>
      <p>
        研究中心将研究成果转化为多种形式，在中国话语与世界文学领域凸显三大特色。其一，以出版文库形成学术生产机制：“上海国别区域全球知识文库·中国话语与世界文学研究丛书”（丛书主编：张帆）第一辑共10部，商务印书馆出版，首推4部。其二，以设立研究专栏促进学术交流对话：研究中心依托教育部重大课题，于综合性人文期刊《中国故事》开设专栏“中国故事的世界传播”，辑录17篇文章。其三，以对标国家战略提升学术应用价值：团队结合研究课题与成果，撰写并提交教育部3篇咨政报告，发挥建言献策、经世致用的智库功能。
      </p>
      <p style="text-align: center;"><strong>三、人文交流，促进思想传播</strong></p>
      <p>
        研究中心积极举办各类学术与人文交流活动，助力凝聚共识，促进中外文明交流互鉴。研究中心主办3次国内学术会议，参会总人数近150人次；举办13次“国别区域全球知识前沿讲坛·中国话语与世界文学研究中心系列讲座”，讲座嘉宾来自学术界、外交界、文化界、出版界等不同领域，其中海外专家学者占比23%；举办16次博士后工作坊及硕博生研讨会，助力青年学人的学术发展；团队成员参与国内、国际学术会议共计14人/次，提交会议论文或作学术报告13篇/次，各类校内外受邀讲学8次。
      </p>
      <p style="text-align: center;"><strong>四、学科建设，开设特色课程</strong></p>
      <p>
        研究中心团队依托科研课题与学术成果，积极探索并开设国别文学文化研究的特色课程，如区域国别学博士生专业课程“德国文学文化史论”、面向全校硕博研究生的公共选修课程“文化记忆理论与实践”，课程评教成绩优异（总得分为100分、99.7分），位列全校前茅；张帆教授荣获2023年“宝钢优秀教学奖”、国家级教学成果奖（研究生），由其担任负责人的相关课程入选国家级一流本科课程。上述课程引导学生对国别文学文化进行深入探究，培养其将来从事相关工作所需的知识能力与专业素养。
      </p>
      <p style="text-align: center;"><strong>五、人才培养，打造一流团队</strong></p>
      <p>
        研究中心引进海内外高层次人才，形成具有学术竞争力的中青年教学科研团队，二级教授1人，博士后5人，覆盖英语、德语、日语等语种，所有成员均有在海外知名高校留学或交流的教育背景，研究方向包括外国语言文学、比较文学与世界文学、跨文化研究等。由张帆教授领衔，团队成员先后入选国家“万人计划”哲学社会科学领军人才、中宣部文化名家暨“四个一批”人才、中国博士后国际交流计划引进项目、上海市“超级博士后”、国家资助博士后研究人员计划等项目。此外，研究中心不断优化平台制度，建立起兼备学术委员会（12名资深专家）、双聘教授（4名校内学者）、特聘研究员（4名行业专家）及兼职研究员（9名青年学者）的学术团队与人才梯队。
      </p>
      <p style="text-align: center;"><strong>六、话语传播，扩大社会影响</strong></p>
      <p>
        研究中心积极探索数字人文实践，建成并运行“世界文学‘中国故事’文献传播与研究数据库”，近万条数据涵盖39个语种，55个国家和地区，打造上外特色数字学术平台。团队充分发挥新媒体的宣传作用，开发官方网站，设立微信公众号，发布最新研究进展、新闻动态、学术资讯等内容，已推送140篇推文，其中原创推文66篇，累计订阅粉丝近2000人，总阅读量超5万人次，单篇推文最高阅读量近3000人次，有力促进了研究中心的对外学术与人文交流，扩大了研究中心与我校的新媒体发声。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
        sources: [
          {
            type: "video/mp4",
            src: "/cms/static/A.mp4", //url地址
          },
        ],
        poster: "/cms/static/A_poster.png", //你的封面地址
      }
    }
  },
  props: {

  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.brief-container {
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }
  p {
    font-size: 16px;
    text-indent: 32px;
    color: #333;
    line-height: 32px;
  }
  ::v-deep .vjs-poster {
    background-size: contain;
  }
  .video-content {
    text-align: center;
    margin: 14px 0;
  }
}

@media screen and (max-width: 768px) {
  .brief-container {
    h2 {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      color: #212529;
      margin-bottom: 20px;
    }
    p {
      font-size: 14px;
      text-indent: 28px;
      color: #333;
      line-height: 28px;
    }
    ::v-deep .vjs-poster {
      background-size: contain;
    }
    .video-content {
      text-align: center;
      margin: 14px 0;
    }
  }
}
</style>